import { NFClientDelivery } from './mappings';

export default rawData =>
    Object.fromEntries(
        Object.keys(NFClientDelivery).map(key => [[NFClientDelivery[key]], rawData[key]])
    );
